import { Icons, Typography, Stack } from '@cast/design-system';

import { PreparedWorkload } from 'features/workload-optimization';

type ValueProps = { value?: number; positive: boolean; testId?: string };
const Value = ({ value, positive, testId }: ValueProps) => {
  return (
    <Typography
      variant="P12R"
      color={!value ? 'grey.300' : positive ? 'green.500' : undefined}
      width="3ch"
      data-testid={testId}
      data-value={value}
      component="div"
    >
      {value || 'N/A'}
    </Typography>
  );
};

export const PodsCell = ({ podCount, replicas }: PreparedWorkload) => {
  const isPositive = podCount === replicas;
  return (
    <Stack direction="row" alignItems="center" data-positive={isPositive}>
      <Value value={podCount} positive={isPositive} testId="current" />
      <Icons.ArrowRight
        css={({ palette }) => ({
          fontSize: 16,
          color: palette.grey[300],
          marginRight: 8,
        })}
      />
      <Value value={replicas} positive={isPositive} testId="desired" />
    </Stack>
  );
};
